// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".business-license .left[data-v-6aee2d7c] {\n  width: 120px;\n}\n.business-license .right[data-v-6aee2d7c] {\n  flex: 1;\n  padding-left: 20px;\n}", ""]);
// Exports
module.exports = exports;
